// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"39d94d3abbc14b81","281":"24c9a440d2d0fbd2","474":"a84dac2fb1a7f242"}[chunkId] + ".js";
};